var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { producerBankAccount as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Add as AddIcon } from '@mui/icons-material';
import { useNotify } from '../../../hooks/notificationHook';
import { LinearProgress, Box, Button, Typography } from '@mui/material';
import BankAccount from '../../organisms/BankAccount';
import { useConfirm } from '../../../hooks/confirmationHook';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var BankAccountWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 16px 0px;\n"], ["\n  margin: 16px 0px;\n"])));
var StyledBox = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var BankAccountsContent = function (_a) {
    var producer = _a.producer;
    var t = useTranslation().t;
    var notify = useNotify();
    var navigate = useNavigate();
    var confirm = useConfirm();
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = React.useState([]), bankAccounts = _c[0], setBankAccounts = _c[1];
    var getAll = useRequest(api.getAll);
    var destroy = useRequest(api.destroy);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getAll({ q: { producer_id_eq: producer.id } })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setBankAccounts(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [producer.id, getAll]);
    var handleDelete = React.useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            confirm('', t("messages.deleteConfirm"), function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, nextData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, destroy(id)];
                        case 1:
                            response = _a.sent();
                            if (!response)
                                return [2 /*return*/];
                            nextData = bankAccounts.filter(function (bankAccount) { return bankAccount.id !== id; });
                            setBankAccounts(nextData);
                            notify('success', [t('messages.deleteSuccess')]);
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); }, [destroy, bankAccounts, notify, t, confirm]);
    if (loading)
        return React.createElement(LinearProgress, null);
    return (React.createElement(Wrapper, null,
        React.createElement(StyledBox, null,
            React.createElement(Button, { variant: "contained", onClick: function () {
                    return navigate("/admin/producers/".concat(producer.id, "/bank_accounts/new"));
                } },
                React.createElement(AddIcon, null),
                t('buttons.addItem'))),
        bankAccounts.length === 0 ? (React.createElement(Typography, null, t('labels.noData'))) : (bankAccounts.map(function (bankAccount) { return (React.createElement(BankAccountWrapper, { key: bankAccount.id },
            React.createElement(BankAccount, { bankAccount: bankAccount, onDelete: handleDelete, onEdit: function () {
                    return navigate("/admin/producers/".concat(producer.id, "/bank_accounts/").concat(bankAccount.id));
                } }))); }))));
};
export default BankAccountsContent;
var templateObject_1, templateObject_2, templateObject_3;
